export const findPackagingFormat = (consumablesMatrixData, packagingFormaId) => {
    return consumablesMatrixData.packagingFormats.find((format) => format.id === packagingFormaId);
};
//# sourceMappingURL=findPackagingFormat.js.map